import { render, staticRenderFns } from "./BannerSlide.vue?vue&type=template&id=0d145f25"
import script from "./BannerSlide.vue?vue&type=script&lang=js"
export * from "./BannerSlide.vue?vue&type=script&lang=js"
import style0 from "./BannerSlide.vue?vue&type=style&index=0&id=0d145f25&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports